import { motion } from "framer-motion";
import { Reveal } from "./Shared";

const SHOTS = [
  { src: "/photos/t1.jpg", alt: "Community post screenshot from Latroshia Bostic about her experience with the course modules" },
  { src: "/photos/t3.jpg", alt: "Community post screenshot from Rachel Powell sharing her January income result" },
  { src: "/photos/t2.jpg", alt: "Community post screenshot from Jenny Rasmussen sharing a UGC gig she landed" },
  { src: "/photos/t4.jpg", alt: "Community post screenshot from Kaitlyn Chupp sharing her six-week income result" },
];

export const Results = () => (
  <section className="bg-[var(--blush)] px-5 py-24 text-center sm:px-8 lg:px-14 lg:py-32" data-testid="section-results">
    <div className="mx-auto max-w-5xl">
      <Reveal>
        <h2 className="font-display text-4xl font-light tracking-tight sm:text-5xl lg:text-6xl" data-testid="results-heading">
          Real <em className="inline-block -rotate-1 bg-[var(--mauve)] px-3 text-white">Results</em>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-testid="results-note">
          These are screenshots of posts shared by other members of The Boss Suite community. Their results are their own, not mine, and are not typical or guaranteed.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2" data-testid="community-screenshots">
        {SHOTS.map((s, i) => (
          <motion.figure
            key={s.src}
            initial={{ opacity: 0, y: 30, rotate: i % 2 ? 1.5 : -1.5 }}
            whileInView={{ opacity: 1, y: 0, rotate: 0 }}
            whileHover={{ y: -6 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden rounded-3xl border border-[var(--blush-deep)] bg-white p-3 shadow-[0_24px_50px_-30px_rgba(46,36,33,0.5)]"
          >
            <img src={s.src} alt={s.alt} loading="lazy" className="aspect-square w-full rounded-2xl object-contain" data-testid={`community-screenshot-${i + 1}`} />
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
